import React from 'react';
import moment from 'moment';
import SelectInput, { IOptions } from '../../../inputs/select-input';
import {
    WrappedComponentProps,
    injectIntl,
    FormattedMessage,
} from 'react-intl';
import {
    IShippingPreference,
    PrecendencType,
} from '../../../../models/shipping-preferences';
import { AccountType } from '../../../../models/account';

interface ShippingPreferencesPanelProps {
    heading: string;
    body?: string;
    isReadOnly?: boolean;
    shippingMethods: IOptions[];
    shippingPreference: IShippingPreference;
    accountType: AccountType;
    namePrefix: string;
    handleChange: (e: React.ChangeEvent<any>) => void;
}

const ShippingPreferencesPanel: React.FC<ShippingPreferencesPanelProps> = ({
    heading,
    body,
    isReadOnly,
    shippingMethods,
    shippingPreference,
    accountType,
    namePrefix,
    handleChange,
}) => {
    const isOverriden =
        accountType === AccountType.ShipTo &&
        shippingPreference.precedence === PrecendencType.BillTo;
    const isDisabled = isReadOnly || isOverriden;

    const selectName = namePrefix
        ? `${namePrefix}.shippingMethod`
        : 'shipppingMethod';

    return (
        <div className="panel panel-default">
            <div className="panel-heading">{heading}</div>
            <div className="panel-body">
                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-12">{body}</div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 gutter-top">
                                {shippingPreference.lastEnabledDate && (
                                    <>
                                        <FormattedMessage id="Last_Updated" />:{' '}
                                        {moment(
                                            shippingPreference.lastEnabledDate
                                        ).format('LL')}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <SelectInput
                            name={selectName}
                            options={shippingMethods}
                            label={'Delivery'}
                            labelClassName=" "
                            fieldClassName=" "
                            defaultOption={'Specify at Ship To Level'}
                            hasDefaultOption={
                                accountType !== AccountType.ShipTo
                            }
                            value={
                                shippingPreference.shippingMethod ||
                                (accountType === AccountType.ShipTo
                                    ? shippingPreference.shippingMethodDefault
                                    : '')
                            }
                            disabled={isDisabled}
                            onChange={handleChange}
                        />
                        {isOverriden && (
                            <div className="alert alert-info">
                                <FormattedMessage id="Shipping_Default_Overridden" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShippingPreferencesPanel;
